export { ErrorBoundary, default, links } from "/Users/mitchel/sites/github/remix-portfolio/app/root.tsx";